// @need-translate
import ClipboardJS from 'clipboard';
import router from 'next/router';
import { MouseEvent, ReactElement, useCallback } from 'react';
import { IsLoginChecker } from '../../../common/checkers/IsLoginChecker';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { requestContext } from '../../../common/requestContext';
import useTypedSelector from '../../../common/useTypedSelector';
import { Layout } from '../../../design-system/layout/Layout';
import { HeaderTitle } from '../../../design-system/organisms/HeaderTitle/HeaderTitle';
import { Info } from '../../../domain/account/info/presentational/Info';
import { CommonMobileHeaderType } from '../../../header/constants';
import { LOG_CLICK_EVENT } from '../../../logging/logEvent';
import { showToast } from '../../../toast/toastHandler';
function AccountInfo() {
  const {
    isMobile
  } = requestContext.requestInfo.display;
  const {
    user
  } = useTypedSelector(state => state.user);
  const onClickCopyUserId = useCallback((e: MouseEvent) => {
    function handler() {
      if (!ClipboardJS.isSupported() || !user?.appUserId) {
        showToast({
          message: '링크를 복사할 수 없습니다.',
          isMobile: requestContext.requestInfo.display.isMobile,
          delayMs: 2000
        });
      } else {
        ClipboardJS.copy(user.appUserId);
        showToast({
          message: t('more_account_info_member_number_copy_toast'),
          isMobile: requestContext.requestInfo.display.isMobile,
          delayMs: 2000
        });
      }
    }
    LOG_CLICK_EVENT('복사_클릭', e, handler);
  }, [user?.appUserId]);
  const onClickProfile = useCallback((e: MouseEvent) => {
    function handler() {
      router.push('/account/profile');
    }
    LOG_CLICK_EVENT('프로필수정_클릭', e, handler);
  }, []);
  const onClickUnregister = useCallback((e: MouseEvent) => {
    function handler() {
      router.push('/account/unregister');
    }
    LOG_CLICK_EVENT('서비스탈퇴_클릭', e, handler);
  }, []);
  return <IsLoginChecker>
      {!isMobile && <HeaderTitle className="mt-20pxr mb-32pxr px-15pxr">
          {t('more_account_info_title')}
        </HeaderTitle>}
      <div className="mx-auto w-full max-w-1200pxr pt-32pxr">
        <Info nickname={user?.nickname} email={user?.email} thumbnail={user?.thumbnail} needProfileUpdate={user?.needProfileUpdate} appUserId={user?.appUserId} onClickProfile={onClickProfile} onClickUnregister={onClickUnregister} onClickCopyUserId={onClickCopyUserId} />
      </div>

      <TrackPageViewContainer trackObj={{
      section: '더보기',
      page: '계정정보',
      actionType: 'Pageview',
      actionName: '계정정보_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </IsLoginChecker>;
}
AccountInfo.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('more_account_info_title')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.ThreeDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true
  }}>
      {page}
    </Layout>;
};
export default AccountInfo;